import React from "react";
import { GameRoot } from "@/components/screens/GameRoot";
import { useAppVersionCheck } from "@/hooks/useAppVersionCheck";

const App = () => {
    return <GameRoot />;
};

export default App;
